import AccountStaffResetPasswordForm from './AccountStaffResetPasswordForm.jsx';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';

import { request as resetUserPassword } from '../../../modules/staff/actions/update';

import decorate from '../../../utils/decorate';

function mapStateToProps(state) {
    return {
        status: state.staff.get('state')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onResetUserPassword: (id, data) => dispatch(resetUserPassword(id, data)),
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    AccountStaffResetPasswordForm
);
